import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { ActivitySubscriptionType } from '@recruitee/activities-types';
import type {
  ActivitySubscriptions,
  ActivitySubscriptionUpdateData,
} from '@recruitee/activities-types';
import { GdprService } from '@recruitee/gdpr-data';
import { I18nService, TranslatePipe } from '@recruitee/i18n';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-followed-by-me-offer',
  templateUrl: './activity-subscriptions-followed-by-me-offer.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ActivitySubscriptionsTableComponent,
    ActivitySubscriptionsTableRowComponent,
    TranslatePipe,
  ],
})
export class ActivitySubscriptionsFollowedByMeOfferComponent {
  @Input()
  public set types(types: ActivitySubscriptionType[]) {
    this.title = types.includes(ActivitySubscriptionType.Slack)
      ? this.i18n.translate('app.subscriptions.followed_by_me_offer_slack')
      : this.i18n.translate('app.subscriptions.followed_by_me_offer');
    this._types = types;
  }

  public get types(): ActivitySubscriptionType[] {
    return this._types;
  }

  @Input() public abilities = {
    viewOffers: false,
    viewCandidates: false,
    manageCandidates: false,
    viewRequisitions: false,
  };
  @Input() public activitySubscriptions: ActivitySubscriptions;
  @Input() public hasOverdueCandidates: boolean = true;
  @Input() public hasRequisitions: boolean = false;
  public changeEvents = output<ActivitySubscriptionUpdateData>();

  public title: string;

  private _types: ActivitySubscriptionType[];

  constructor(
    public gdprSvc: GdprService,
    private i18n: I18nService,
  ) {}
}
